import { render, staticRenderFns } from "./UserRaffleRecord.vue?vue&type=template&id=641d9b50&scoped=true"
import script from "./UserRaffleRecord.vue?vue&type=script&lang=js"
export * from "./UserRaffleRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641d9b50",
  null
  
)

export default component.exports